import React, { useEffect, useState } from 'react';

import { Circle, Tag, TagLabel, Text, forwardRef } from '@chakra-ui/react';
import { Flex, Icon } from '@firehydrant/design-system';

import { queryClient } from '../../../helpers/SPAWrapper';
import ToolbarPopover from './ToolbarPopover';
import { Check, Warning } from '@phosphor-icons/react';

const QueryChecker = () => {
  const [activeQueries, setActiveQueries] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const checkQueries = () => {
    try {
      // Get all queries from React Query v3 client
      const queries = queryClient.getQueryCache().getAll();
      setActiveQueries(queries);
    } catch (error) {
      console.error('Error checking query client:', error);
    } finally {
      setLoading(false);
    }
  };

  const QueryPopoverTrigger = forwardRef((props, ref) => {
    return (
      <Circle
        size="20px"
        bg={
          activeQueries.length > 0
            ? 'surface.feedback.critical.sharp'
            : 'surface.feedback.success.sharp'
        }
        color="content.inverse"
        _hover={{ cursor: 'pointer' }}
        ref={ref}
      >
        <Icon
          as={activeQueries.length > 0 ? Warning : Check}
          boxSize="14px"
          opacity={activeQueries.length > 0 ? 1 : 0.5}
        />
      </Circle>
    );
  });

  useEffect(() => {
    checkQueries();
    const queryInterval = setInterval(checkQueries, 10000);

    return () => clearInterval(queryInterval);
  }, []);

  if (isLoading) return <Circle size="20px" backgroundColor="grey.300" />;

  return (
    <ToolbarPopover trigger={<QueryPopoverTrigger />}>
      <Flex direction="column" gap={2}>
        <Flex alignItems="center" gap={2}>
          <Tag
            colorScheme={activeQueries.length > 0 ? 'yellow' : 'green'}
            variant="status"
          >
            <TagLabel fontSize="xs">
              {activeQueries.length} v3{' '}
              {activeQueries.length === 1 ? 'query' : 'queries'}
            </TagLabel>
          </Tag>
          <Text textStyle="body1" color="content.inverse">
            React Query v3 Migration Status
          </Text>
        </Flex>

        {activeQueries.length > 0 ? (
          <Flex direction="column" gap={1} mt={2}>
            <Text textStyle="body2" color="content.inverse">
              Active v3 Queries:
            </Text>
            {activeQueries.map((query, index) => (
              <Text
                key={index}
                textStyle="body1"
                color="content.inverse"
                mb="1"
              >
                {query.queryKey
                  ? Array.isArray(query.queryKey)
                    ? query.queryKey.join(' → ')
                    : String(query.queryKey)
                  : 'Unknown Query'}
              </Text>
            ))}
          </Flex>
        ) : (
          <Text textStyle="body2" color="content.inverse">
            No active v3 queries detected. Migration complete!
          </Text>
        )}
      </Flex>
    </ToolbarPopover>
  );
};

export default QueryChecker;
